import { createSlotRecipe } from './runtime.js';

const chatSurfaceConfig = {"name":"chatSurface","slots":["paper","field","ghostButton","inkButton","mono"]}

export const chatSurface = /* @__PURE__ */ createSlotRecipe(chatSurfaceConfig)